import * as React from 'react'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import { cartStore, ICartItem } from '../../cart'
import { IProduct } from '../product.interfaces'
import { ProductStates } from '../product.enums'
import './remove-from-cart.scss'

interface IProps {
  product: IProduct
}

@observer
export class RemoveFromCart extends React.Component<IProps> {
  baseClass: string = 'remove-from-cart'

  get productId(): string {
    return this.props.product.id
  }

  render(): React.ReactNode {
    const item = cartStore.items.get(this.productId)
    const isLoading = cartStore.removeItemFromCartLoading === this.productId
    // const isLoading = true

    if (!item) {
      return null
    }

    const buttonProps: object = {
      'data-gtm-id': 'product-remove-from-cart',
      className: classNames({
        [this.baseClass]: true,
        [`${this.baseClass}__loading`]: isLoading
      }),
      ...{ onClick: (): void => cartStore.removeFromCart(this.props.product) }
    }
    return (
      <button type='button' {...buttonProps}>
        Remove from cart
        {isLoading && <div className='loading__spinner' />}
      </button>
    )
  }
}
